import React from "react";
import { T } from "../../constants/theme";

/** Server log row */
const ServerLogRow = ({ log }) => {
  const levelColor =
    { WARN: T.yellow, ERROR: T.red, ALERT: T.orange, INFO: T.green }[log.level] || T.muted;

  return (
    <div className="sad-log-row">
      <span
        className="sad-log-level"
        style={{ background: `${levelColor}20`, color: levelColor }}
      >
        {log.level}
      </span>
      <div>
        <span style={{ fontSize: "11px", color: T.text }}>{log.message}</span>
        <span style={{ fontSize: "10px", color: T.muted, marginLeft: "6px" }}>{log.time}</span>
      </div>
    </div>
  );
};

export default ServerLogRow;
